import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaChevronUp } from "react-icons/fa"; // Added Chevron icon
import axios from "axios";

const Footer = () => {
  const [homeProducts, setHomeProducts] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    fetchHomeProducts();
  }, []);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top coordinate to 0, make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const fetchHomeProducts = () => {
    axios
      .post(`${BASE_URL}/api/product/getHome`) // your API endpoint
      .then((response) => {
        if (response.data.product.length > 0) {
          setHomeProducts(response.data.product); // Store product data
        }
      })
      .catch((err) => { });
  };

  return (
    <footer className="footer-area">
      <div className="footer-main">
        <div className="container">
          <div className="row gy-4">
            {/* Brand */}
            <div className="col-lg-3 col-md-6">
              <div className="widget-item">
                <a href="/" className="footer-logo">
                  <img src="/assets/img/sachi_logo.png" alt="Sachi Logo" />
                </a>
                <p className="footer-about">
                  Sachi Products Delivers Premium Quality Products competitive prices, built on trust and long term relationships with over 30 years of experience.
                </p>
              </div>
            </div>

            {/* Info */}
            <div className="col-lg-2 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title ">Quick Links</h4>
                <div className="title-separator"></div>
                <ul className="footer-links">
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link to="/product">Products</Link>
                  </li>
                  <li>
                    <Link to="/inquiry">Inquiry</Link>
                  </li>
                  <li>
                    <Link to="/contact_us">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Categories */}
            {/* <div className="col-lg-3 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Product Categories</h4>
                <div className="title-separator"></div>
              </div>
              <ul className="footer-links">
                {homeProducts.slice(0, 7).map((product) => (
                  <li key={product.id}>
                    <Link to={`/product_images/${product.id}/${product.name}`}>
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div> */}

            <div className="col-lg-3 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Product Categories</h4>
                <div className="title-separator"></div>
              </div>
              <ul className="footer-links">
                <li><Link to="/product_by_category/1">Crockery</Link></li>
                <li><Link to="/product">Cutlery</Link></li>
                <li><Link to="/product">Glassware</Link></li>
                <li><Link to="/product">Presentation Tableware</Link></li>
                <li><Link to="/product">Catering Products</Link></li>
                <li><Link to="/product">Electric Equipments</Link></li>
                <li><Link to="/product">Chafing Dishes</Link></li>
                <li><Link to="/product">Food Packaging</Link></li>
                <li><Link to="/product">House Keeping</Link></li>
                <li><Link to="/product">Others</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-4 col-md-6">
              <div className="widget-item">
                <h4 className="widget-title">Contact Us</h4>
                <div className="footer_title-separator"></div>
                <div class="contact-address">
                  <i class="fa fa-map-marker-alt"></i>

                  <div class="address-text">
                    1st Floor, Sachi House, Above Patel Ice Cream,
                    Commerce Six Rd, Navrangpura,
                    Ahmedabad
                  </div>
                </div>
                <div className="footer-contact">
                  <i className="fas fa-phone-alt"></i>
                  <span className="ml-10">+91 9662917174 / 9824595370 </span>
                </div>


                <div className="footer-contact">
                  <i className="fas fa-phone-alt"></i>
                  <span className="ml-10">+91 79 - 2644 2095 /96</span>
                </div>

                <div
                  className="footer-contact"
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  {/* Use <a> tags for external websites */}
                  <a
                    href="https://www.facebook.com/sachiproducts1996"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-facebook-f"
                      style={{ fontSize: "28px" }}
                    ></i>
                  </a>

                  <a
                    href="https://www.instagram.com/sachiproducts1996/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-instagram"
                      style={{ fontSize: "28px" }}
                    ></i>
                  </a>

                  <a
                    href="https://www.youtube.com/@SACHIPRODUCTS"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className="fab fa-youtube"
                      style={{ fontSize: "28px" }}
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container text-center">
          <p className="footer-copyright-text">
            © 2026{" "}
            <a
              href="https://sachiproducts.com"
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Sachi Products</strong>
            </a>
            <span className="footer-separator">
              {" "}
              | Designed & Developed by{" "}
              <a
                href="https://theaditech.in"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link developer-link"
              >
                <strong>TheAdiTech</strong>
              </a>
            </span>
          </p>
        </div>
      </div>

      {/* --- SCROLL TO TOP BUTTON --- */}
      {isVisible && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <FaChevronUp />
        </div>
      )}
    </footer>
  );
};
export default Footer;
